import store from "@/store";

import mApp from "@/modules/app";

export default {
  async getEmployee(payload) {
    let employeeCode = payload?.code;
    let employeePin = payload?.pin;
    if (!employeeCode && !employeePin) return { result: "No employee code or pin provided" };

    let resp = await mApp.apiPost(store.getters.dcApiUrl + "/employee", {
      sessionKey: store.getters.serviceSessionKey,
      get: { EmployeeCode: employeeCode, EmployeeAlias: employeePin },
    });

    let respGet = resp?.get;
    if (!respGet) {
      respGet = { result: "Failed to get employee" };
    }

    return respGet;
  },
};
